import { Component, OnInit, ViewChild } from '@angular/core';
import { TemplateService } from '../templates/template.service';
import { Router } from '@angular/router';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Iconlibrarydialog } from '../bots/bots.component';
import { CheckDemoDialog } from './add-template/add-template.component';

@Component({
  selector: 'app-templates',
  templateUrl: './templates.component.html',
  styleUrls: ['./templates.component.css']
})
export class TemplatesComponent implements OnInit {
  merchantId: string;
  loginUserDetails: any;
  allTemplateDetails: any = [];
  apiKeyIsGenerated: boolean = false;
  DeleteTemplateName = "";
  @ViewChild('DeleteTemplate') DeleteTemplate;

  constructor(private templateService: TemplateService, public _matDialog: MatDialog, private router: Router,public dialog: MatDialog) { }

  ngOnInit() {
    this.loginUserDetails = JSON.parse(
      localStorage.getItem('loginUserDetails')
    );
    this.merchantId = this.loginUserDetails.merchant_id;
    this.getAllTemplateDetails();
    if(localStorage.getItem('apiKey')) {
      this.apiKeyIsGenerated = true;
    }
  }
  getAllTemplateDetails() {
    this.templateService.getTemplateDetailsByMerchantId(this.merchantId).subscribe(
      (res) => {
        res.data.map(x => { x.created_at = new Date(x.created_at); });
        this.allTemplateDetails = res.data.sort((a, b) => { return b.created_at - a.created_at; });
       },
      (error) => {}
    );
  }
  goToEditTemplate(name) {
    this.router.navigateByUrl('templates/edit/' + name);
  }

  openCheckDemo(){
    this.dialog.open(CheckDemoDialog)
  }
  
  onCancel(){
    this.DeleteTemplateName = ""
    this._matDialog.closeAll()


  }
  onDeleteTemplate(name){
    this.DeleteTemplateName = name
    this._matDialog.open(this.DeleteTemplate, {
      panelClass: 'custom-delete-template-container',
      position: {
        'top' : '18%',
        'left' : '40%'
      }
    });
  }
  deleteConfirmation(){
    this.templateService.deleteTemplate(this.DeleteTemplateName).subscribe((res)=>{
      if(res =="OK"){
        this.getAllTemplateDetails()
        this._matDialog.closeAll()
      }
      
    })
  }

}